import styles from './Stepper.module.css';

type Props = {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max: number;
  label?: string;
};

export function Stepper({ value, onChange, min = 0, max, label }: Props) {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  const canDec = value > min;
  const canInc = value < max;

  return (
    <div className={styles.wrap}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.stepper}>
        <button
          type="button"
          className={styles.btn}
          aria-label="Weniger"
          onClick={dec}
          disabled={!canDec}
        >
          <i className="ph ph-minus" aria-hidden="true" />
        </button>
        <span className={styles.value} aria-live="polite">{value}</span>
        <button
          type="button"
          className={styles.btn}
          aria-label="Mehr"
          onClick={inc}
          disabled={!canInc}
        >
          <i className="ph ph-plus" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
